function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.99735 9.79527V16.9473H5.37065V9.82727H7.66853L8.22558 6.85927H5.4016C5.4016 6.85927 5.4016 5.45927 5.4016 4.67527C5.4016 4.37927 5.55634 3.97127 6.02056 3.97127C6.74783 3.97127 7.66079 3.97127 7.66079 3.97127V0.947266C7.66079 0.947266 6.1753 0.947266 4.59696 0.947266C3.54473 0.947266 1.99735 2.29127 1.99735 3.71527C1.99735 5.18727 1.99735 6.77127 1.99735 6.77127H0.225586V9.77927L1.99735 9.79527Z",
  fill: "currentColor"
});
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.936a6f9d.svg";
export { ForwardRef as ReactComponent };